<form [formGroup]="form">
  <div class="form-group" *ngIf="!templateForPermitForm">
    <label class="bmd-label-floating" for="searchName">Search</label>
    <input
      type="text"
      class="form-control"
      [(ngModel)]="searchText"
      formControlName="searchText"
      name="searchName"
    />
  </div>
  <!--      added by priya 03-12-2025  
 -->

  <div class="form-group" *ngIf="templateForPermitForm">
    <wm-common-textfield
      controlName="fullName"
      [data]="{
      label: 'Search',
    }"
          [(ngModel)]="searchText"
          formControlName="searchText"
    
    ></wm-common-textfield>
  </div>
  <!--      end by priya 03-12-2025  
 -->
</form>
